import { Component, inject } from '@angular/core';
import { BaseComponent, DialogRef } from '@shared/classes';
import { ButtonComponent } from '@shared/components/button/button.component';
import {
  DialogCloseButton,
  OptinsCloseConfirmationDialog,
} from '@shared/models';
import { SafePipe } from '@shared/pipes';

@Component({
  imports: [SafePipe, ButtonComponent],
  selector: 'b2c-close-confirmation-modal',
  styleUrl: './close-confirmation-modal.component.scss',
  templateUrl: './close-confirmation-modal.component.html',
})
export class CloseConfirmationModalComponent extends BaseComponent {
  public config: OptinsCloseConfirmationDialog = this.loyaltyChallengeConfig
    .components.modals.optinsCloseConfirmation as OptinsCloseConfirmationDialog;

  public closeButtonConfig: DialogCloseButton =
    this.loyaltyChallengeConfig.components.modals.optinsCloseConfirmation
      ?.actionButtons.closeButton ||
    this.loyaltyChallengeConfig.components.modals.closeButton;

  private readonly dialogRef: DialogRef = inject(DialogRef);

  /**
   * Close DialogRef Reference
   */
  closeDialog(returnToConsentPopin: boolean): void {
    this.dialogRef.close(returnToConsentPopin);
  }
}
